<div class="rendition-split-movement-container">
  <p class="primary-text">
    Aún quedan movimientos sin registrar. Los movimientos restantes a generar
    son:
  </p>

  <div class="table-container">
    <!-- TABLE HEADER -->
    <app-table-header-new
      class="table-header"
      [tableHeader]="tableHeader"
      [isCheckboxColumnVisible]="false"
      [orderByOrientationDefault]="'DES'"
    ></app-table-header-new>
    <div class="row" *ngFor="let m of listMovement; let i = index">
      <div
        class="column"
        *ngFor="let key of listMovementKey; let ic = index"
        [ngStyle]="{ width: tableHeader[ic].percentageWidth + '%' }"
        [ngClass]="{ bold: ic == 5 }"
      >
        {{ this.listMovement[i][key]}}
      </div>
    </div>
  </div>
  <p class="subtext">
    Puede agregarlos y finalizar la edición de movimientos o puede agregarlos manualmente
  </p>
</div>
